import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  constructor(
    private api$: ApiService,
    private authService: AuthService,
    private router: Router,
    private localStorage: LocalStorageService
  ) {}

  async logoutNurse(mobileAppObj: any): Promise<void> {
    if (!mobileAppObj) return;

    await this.deleteFirebaseTokenIfExists(mobileAppObj);
    await this.logoutSession();
  }

  private async deleteFirebaseTokenIfExists(mobileAppObj: any): Promise<void> {
    const firebaseToken =
      mobileAppObj.getFirebaseToken() ||
      this.localStorage.retrieve('firebaseToken');

    if (!firebaseToken) return;

    try {
      const resp: any = await this.api$.deleteFirebaseToken({ token: firebaseToken }).toPromise();
      if (resp?.success) {
        console.log('Firebase token deleted');
      }
    } catch (error) {
      console.error('Failed to delete Firebase token', error);
    }
  }

  public async deleteLocalFirebaseToken(): Promise<void> {

    const firebaseToken = this.localStorage.retrieve('firebaseToken');

    if (!firebaseToken) return;

    try {
      const resp: any = await this.api$.deleteFirebaseToken({ token: firebaseToken }).toPromise();
      if (resp?.success) {
        console.log('Firebase token deleted');
        this.localStorage.clear('firebaseToken');

      }
    } catch (error) {
      console.error('Failed to delete Firebase token', error);
    }

  }

  private async logoutSession(): Promise<void> {
    const sessionData = this.getSessionData();

    try {
      const resp: any = await this.api$.doLogoutAut(sessionData).toPromise();
      if (!resp?.success) {
        alert(resp?.data?.message);
        return;
      }

      this.authService.logout();
      await this.router.navigate(['/screen/nurses-login']);
    } catch (error) {
      alert('The session has NOT been deleted successfully! ' + error?.statusText);
    }
  }

  private getSessionData(): any {
    return {
      session: {
        loggedUser: this.localStorage.retrieve('loggedUser'),
        token: this.localStorage.retrieve('token'),
      },
    };
  }
}